import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 1rem;
`;

export const CarouselContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	overflow: hidden;
	scroll-behavior: smooth;
	scroll-snap-type: x mandatory;
	-webkit-overflow-scrolling: touch;
	transition: all ease 0.5s;
	gap: 1rem;
`;

export const CarouselItem = styled.div`
	scroll-snap-align: center;
	flex: 0 0 auto;
	width: 93%;
	min-height: 100%;
	display: grid;
	grid-template-rows: 1.5fr 1fr;
	gap: 1rem;
	border-radius: 5px;
	border: 1px solid ${color.interface.lightGray2};
`;

interface ImageTagProps {
	$objectFitImg: 'cover' | 'fill' | 'contain';
}

export const imageTag = styled.div<ImageTagProps>`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	> img {
		width: 100%;
		height: 100%;
		border-top-left-radius: 3px;
		border-top-right-radius: 3px;
		object-fit: ${(props) => props.$objectFitImg};
	}
`;

export const clicks = styled.div`
	position: absolute;
	bottom: 0px;
	right: 0px;
	border-top-left-radius: 5px;
	background-color: ${color.interface.darkgray2};
	padding: 1px 5px;
	font-weight: 900;
	font-size: 1.3rem;
	z-index: 10;

	> p {
		font-size: 1rem;
		color: ${color.interface.white};
	}
`;

export const ButtonRight = styled.button`
	all: unset;
	position: absolute;
	right: 0;
	top: 45%;
	cursor: pointer;
	> svg {
		font-size: 3rem;
		color: ${color.interface.white};
	}
`;

export const ButtonLeft = styled.button`
	all: unset;
	position: absolute;
	left: 0;
	top: 45%;
	cursor: pointer;
	> svg {
		font-size: 3rem;
		color: ${color.interface.white};
	}
`;

export const containerBallsInsideCarousel = styled.div`
	position: absolute;
	bottom: 5px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	gap: 1rem;
	padding: 0.5rem 0;
`;

export const containerBallsOutsideCarousel = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	gap: 1rem;
	padding: 0.5rem 0;
`;

interface BallProps {
	$selected: boolean;
}

export const ball = styled.div<BallProps>`
	min-width: ${(props) => (props.$selected ? '14px' : '8px')};
	min-height: 8px;
	border-radius: ${(props) => (props.$selected ? '10px' : '50%')};
	background-color: ${(props) =>
		props.$selected ? color.interface.darkgray : color.interface.lightGray2};
	transition: all ease 0.5s;
`;

export const centralizeNotice = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	> p {
		font-size: 1.4rem;
		font-weight: 900;
	}
`;

export const infos = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: flex-start;
	justify-content: flex-start;
	padding: 0.5rem;
`;

export const title = styled.h3`
	color: ${color.interface.purple};
	font-size: 1.5rem;
`;

export const subtitle = styled.p`
	font-size: 1.3rem;
	color: ${color.interface.darkgray};
	text-align: justify;
`;

export const description = styled.p`
	font-size: 1.2rem;
	color: ${color.interface.darkgray};
	text-align: justify;
`;
